const timeZone = "Europe/Zagreb";

const jobNames = {
  ScrapeNewAdsJob: "Novi oglasi",
  ScrapeExistingAdsDetailsJob: "Detalji postojećih",
};

const statusNames = {
  ok: "OK",
  error: "Greška",
  timeout: "Timeout",
  skipped: "Preskočen",
};

const sourceNames = {
  njuskalo: "Njuškalo",
  nekretnine: "Nekretnine.hr",
  index: "Index",
};

const pad = (value) => String(value).padStart(2, "0");

// "28.10. 12:13" in Europe/Zagreb regardless of the browser's time zone.
export const formatRunStart = (value) => {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) {
    return "-";
  }
  const parts = {};
  new Intl.DateTimeFormat("en-GB", {
    timeZone,
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  })
    .formatToParts(date)
    .forEach((part) => {
      parts[part.type] = part.value;
    });
  return `${parts.day}.${parts.month}. ${parts.hour}:${parts.minute}:${parts.second}`;
};

export const formatRunDuration = (seconds) => {
  if (typeof seconds !== "number" || !Number.isFinite(seconds) || seconds < 0) {
    return "-";
  }
  const total = Math.round(seconds);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const rest = total % 60;
  if (hours > 0) {
    return `${hours} h ${pad(minutes)} min`;
  }
  if (minutes > 0) {
    return `${minutes} min ${pad(rest)} s`;
  }
  return `${rest} s`;
};

export const formatInsertedAds = (run) => {
  if (!run || typeof run.insertedAds !== "number") {
    return "-";
  }
  return String(run.insertedAds);
};

export const formatInsertedBySource = (run) => {
  if (!run || !run.insertedBySource) {
    return "";
  }
  return Object.entries(run.insertedBySource)
    .filter(([, count]) => count > 0)
    .map(([source, count]) => `${sourceNames[source] || source}: ${count}`)
    .join(", ");
};

export const formatRunJob = (job) => jobNames[job] || job || "-";

export const formatRunStatus = (status) => statusNames[status] || status || "-";
